'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface WhatsAppButtonProps {
  currentLanguage: string;
}

const WhatsAppButton = ({ currentLanguage }: WhatsAppButtonProps) => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsHydrated(true);

    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const messages = {
    en: 'Welcome to Gencarbon - The Best ESG solution for you',
    hi: 'Gencarbon में आपका स्वागत है - आपके लिए सर्वश्रेष्ठ ESG समाधान',
    ar: 'مرحبًا بك في Gencarbon - أفضل حل ESG لك'
  };

  const whatsappNumber = '+919901503669';
  const message = encodeURIComponent(messages[currentLanguage as keyof typeof messages] || messages.en);

  if (!isHydrated || !isVisible) return null;

  return (
    <a
      href={`https://wa.me/${whatsappNumber}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 w-14 h-14 bg-conversion text-conversion-foreground rounded-full flex items-center justify-center shadow-natural-lg hover:shadow-natural-xl hover:scale-110 transition-all duration-300 ease-organic z-50 animate-fade-in"
      aria-label="Contact us on WhatsApp"
    >
      <Icon name="ChatBubbleLeftRightIcon" size={28} />
    </a>
  );
};

export default WhatsAppButton;